export const electricModelSlug = ['mustang-mach-e', 'mustang-mache', 'mache', 'mach-e', 'f-150-lightning', 'lightning']
